import { render, staticRenderFns } from "./userListByRole.vue?vue&type=template&id=081fb04c&scoped=true&"
import script from "./userListByRole.vue?vue&type=script&lang=js&"
export * from "./userListByRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081fb04c",
  null
  
)

export default component.exports